import { useQuery } from '@tanstack/react-query';
import { popupApiAdapter } from '../adapters/PopupApiAdapter';
import type { PopupEventsFilters } from '../models/PopupEvent';

const DEFAULT_SORTING: PopupEventsFilters['sorting'] = {
  column: 'occurred_at',
  direction: 'desc',
};

export function usePopupEvents(
  popupId: number | null,
  filters: Omit<PopupEventsFilters, 'sorting'> & { sorting?: PopupEventsFilters['sorting'] },
) {
  const queryFilters: PopupEventsFilters = {
    page: filters.page ?? 1,
    perPage: filters.perPage ?? 15,
    type: filters.type,
    team_id: filters.team_id,
    sorting: filters.sorting ?? DEFAULT_SORTING,
  };

  const queryKey = ['popups', 'events', popupId, queryFilters];

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey,
    queryFn: () => popupApiAdapter.getPopupEvents(popupId!, queryFilters),
    enabled: popupId != null,
    staleTime: 60 * 1000,
  });

  return {
    events: data?.data ?? [],
    meta: data?.meta,
    isLoading,
    isFetching,
    error,
    refetch,
  };
}
